module.exports = __webpack_public_path__ + "img/gzh.00e62b08.jpg";